import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { UpsellBanner } from './banner';
import { CmdbUpsellCommonBase } from './common-base';
import { messages } from './messages';

const LearnMoreButton = () => {
	const { formatMessage } = useIntl();
	return (
		<Button
			appearance="link"
			spacing="none"
			href="https://www.atlassian.com/software/jira/service-management/features/asset-and-configuration-management"
			target="_blank"
			onClick={(_, analyticsEvent) => {
				fireUIAnalytics(analyticsEvent, 'cmdbUpsellLearnMore');
			}}
		>
			{formatMessage(messages.learnMore)}
		</Button>
	);
};

export const ServicesUpsellBanner = () => {
	const { formatMessage } = useIntl();
	return (
		<CmdbUpsellCommonBase variation="services">
			<UpsellBanner
				title={formatMessage(messages.servicesTitle)}
				primaryAction={formatMessage(messages.tryItNow)}
				secondaryAction={formatMessage(messages.maybeLater)}
				bannerArea="services"
			>
				<p>{formatMessage(messages.servicesDescription)}</p>
				<ContentWrapper>
					<LearnMoreButton />
				</ContentWrapper>
			</UpsellBanner>
		</CmdbUpsellCommonBase>
	);
};

export const FeaturesUpsellBanner = () => {
	const { formatMessage } = useIntl();
	return (
		<CmdbUpsellCommonBase variation="features">
			<UpsellBanner
				title={formatMessage(messages.featuresTitle)}
				primaryAction={formatMessage(messages.tryItNow)}
				secondaryAction={formatMessage(messages.maybeLater)}
				bannerArea="features"
			>
				<p>{formatMessage(messages.featuresDescription)}</p>
				<ContentWrapper>
					<LearnMoreButton />
				</ContentWrapper>
			</UpsellBanner>
		</CmdbUpsellCommonBase>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentWrapper = styled.div({
	textAlign: 'left',
});
